/**
 * Standardized Analytics Constants
 * 
 * Consistent naming across all analytics events to ensure proper data analysis
 */

// Standardized tool names (kebab-case)
export const TOOL_NAMES = {
  TRANSCRIPTION_ASSISTANT: 'transcription-assistant',
  INTERVIEW_NOTETAKER: 'interview-notetaker', 
  SURVEY_GUARD: 'survey-guard',
  TAB_PLAN_GENERATOR: 'tab-plan-generator'
} as const

// Page names for navigation events (kebab-case)
export const PAGE_NAMES = {
  DASHBOARD: 'dashboard',
  COMMUNITY_APPS: 'community-apps',
  TRANSCRIPTION: 'transcription-assistant', // Same as tool name for tool pages
  NOTE_TAKING: 'interview-notetaker',       // Same as tool name for tool pages
  SURVEY_ANALYSIS: 'survey-guard',          // Same as tool name for tool pages
  TAB_PLAN_GENERATOR: 'tab-plan-generator'   // Same as tool name for tool pages
} as const

// Path to tool/page mapping for consistent naming
export const PATH_TO_PAGE_MAP: Record<string, string> = {
  '/': PAGE_NAMES.DASHBOARD,
  '/dashboard': PAGE_NAMES.DASHBOARD,
  '/community-apps': PAGE_NAMES.COMMUNITY_APPS,
  '/transcription': PAGE_NAMES.TRANSCRIPTION,
  '/note-taking': PAGE_NAMES.NOTE_TAKING,
  '/survey-analysis': PAGE_NAMES.SURVEY_ANALYSIS,
  '/tab-plan-generator': PAGE_NAMES.TAB_PLAN_GENERATOR
}

// Check if a page has an associated tool
export const PAGE_TO_TOOL_MAP: Record<string, string | null> = {
  [PAGE_NAMES.DASHBOARD]: null,
  [PAGE_NAMES.COMMUNITY_APPS]: null,
  [PAGE_NAMES.TRANSCRIPTION]: TOOL_NAMES.TRANSCRIPTION_ASSISTANT,
  [PAGE_NAMES.NOTE_TAKING]: TOOL_NAMES.INTERVIEW_NOTETAKER,
  [PAGE_NAMES.SURVEY_ANALYSIS]: TOOL_NAMES.SURVEY_GUARD,
  [PAGE_NAMES.TAB_PLAN_GENERATOR]: TOOL_NAMES.TAB_PLAN_GENERATOR
}

export type ToolName = typeof TOOL_NAMES[keyof typeof TOOL_NAMES]
export type PageName = typeof PAGE_NAMES[keyof typeof PAGE_NAMES]
